import { Menus } from '../main/app/Menu';

import { WindowLabel } from './window.types';

export enum MenuEventType {
  ContextMenu = 'context-menu',
}

export type MenuType = keyof typeof Menus;

export const MenuTypes = {
  default: 'default' as const,
} as const satisfies Record<string, MenuType>;

export type ContextMenuPayload<T = Record<string, unknown>> = {
  window: WindowLabel;
  type: MenuType;
  args?: T;
};
